module.exports = __webpack_public_path__ + "media/images/file-o-91f53302fb253633e92c4d3eed855c60.svg";